import '@fortawesome/fontawesome-pro/css/all.min.css';

import * as Sentry from '@sentry/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App.jsx';
import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';

//import * as serviceWorkerRegistration from './misc/serviceWorkerRegistration.js';

// import reportWebVitals from './misc/reportWebVitals.js';

if (import.meta.env.DEV) {
    console.warn('skipping sentry init [development env]');
} else {
    console.warn('initializing sentry client');
    Sentry.init({
        dsn: 'https://ae05ebfbd18b90112de2a00c42ada757@o173608.ingest.us.sentry.io/4509091187523584',
        integrations: [
            Sentry.browserTracingIntegration(),
            //Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            'localhost',
            /^https:\/\/v2.reachsms\.vip\/api/,
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

export const queryClient = new QueryClient();
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition='bottom-left'
        />
    </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
